import { z } from 'zod';

const blemishEntryBaseSchema = z.object({
    location: z
        .string()
        .min(3, 'Blemish location must be at least 3 characters')
        .max(40, 'Blemish location must be at most 40 characters'),
    description: z
        .string()
        .min(10, 'Blemish description must be at least 10 characters')
        .max(140, 'Blemish description must be at most 140 characters'),
    images: z
        .array(z.string().url())
        .max(3, 'A blemish entry can have at most 3 images')
        .default([]),
    videos: z
        .array(z.string().url())
        .max(3, 'A blemish entry can have at most 3 videos')
        .default([]),
});
const blemishEntrySchema = blemishEntryBaseSchema.superRefine((data, ctx) => {
    if (data.images.length + data.videos.length > 3) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'A blemish entry can have at most 3 media items (images + videos combined)',
            path: ['videos'],
        });
    }
});
const cosmeticReportSchema = z.object({
    /** Whether the cosmetic report section is shown on the vehicle listing page */
    isEnabled: z.boolean().optional(),
    /** Overall condition rating: 1 (excellent), 2 (good), 3 (fair) */
    conditionLevel: z.union([z.literal(1), z.literal(2), z.literal(3)]).optional(),
    /** Human-readable summary of the vehicle's cosmetic condition */
    conditionSummary: z.string().optional(),
    /** List of individual blemishes found on the vehicle */
    blemishes: z.array(blemishEntrySchema),
    /** Unix ms timestamp of the last report update */
    updatedAt: z.number(),
});
/**
 * Form schema for the blemish report editor.
 * Extends blemishEntrySchema but relaxes image validation — no URL format
 * check and defaults to [] — so the form works with empty/partial slots.
 */
const blemishReportFormSchema = z.object({
    isEnabled: z.boolean().default(true),
    blemishes: z.array(blemishEntryBaseSchema.extend({
        images: z.array(z.string()).max(3).default([]),
    })),
    summary: z.string().max(300).optional(),
});

export { blemishEntrySchema, blemishReportFormSchema, cosmeticReportSchema };
//# sourceMappingURL=CosmeticReport.js.map
